const lang = {
  en: {
    searchPlaceHolder: "What would you like to watch today...",
    trending: "Trending Movies",
    popular: "Popular Movies",
    upComing: "Upcoming Movies",
    topRated: "Top Rated Movies",
    account: "Account",
    home: "Home",
    search: "Search",
    movies: "Movies",
    logout: "Logout",
    likeThis: "More Like This",
    cast: "Casts",
  },
  hindi: {
    searchPlaceHolder: "आज आप क्या देखना चाहेंगे...",
    trending: "ट्रेंडिंग फिल्में",
    upComing: "आगामी फ़िल्में",
    popular: "लोकप्रिय फ़िल्में",
    topRated: "शीर्ष रेटेड फिल्मे",
    account: "खाता",
    home: "घर",
    search: "खोज",
    movies: "चलचित्र",
    logout: "लॉग_आउट",
    likeThis: "संबंधित चलचित्र",
    cast: "श्रेय",
  },
  spanish: {
    searchPlaceHolder: "¿Qué te gustaría ver hoy...",
    trending: "Películas de moda",
    upComing: "Próximas películas",
    popular: "Películas populares",
    topRated: "Películas mejor valoradas",
    account: "Cuenta",
    home: "Hogar",
    search: "Buscar",
    movies: "Películas",
    logout: "CerrarSesión",
    likeThis: "Más como esto",
    cast: "Moldes",
  },
};

export default lang;
